import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/bookmark': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 0H48C21.5 0 0 21.5 0 48V512L192 400 384 512V48C384 21.5 362.5 0 336 0zM336 428.4L192 344.4 48 428.4V54A6-6 0 0 0 54 48H330C333.3 48 336 50.7 336 54V428.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/bookmark.js
// module id = Iwdz
// module chunks = 144